/**
 * Exchanges API
 *
 * Product exchange management endpoints for admin viewing.
 */

import { apiClient } from './client';
import type {
  ExchangeDetails,
  ExchangeListItem,
  ExchangeStatus,
} from './types';

export interface ExchangeListParams {
  status?: ExchangeStatus;
  locationId?: string;
  limit?: number;
}

export const exchangesApi = {
  /**
   * List exchanges with optional filters
   */
  async list(params: ExchangeListParams = {}): Promise<{ exchanges: ExchangeListItem[] }> {
    const queryParams = new URLSearchParams();
    if (params.status) {
      queryParams.set('status', params.status);
    }
    if (params.locationId && params.locationId !== 'all') {
      queryParams.set('locationId', params.locationId);
    }
    if (params.limit) {
      queryParams.set('limit', params.limit.toString());
    }
    const query = queryParams.toString();
    return apiClient.request(`/exchanges${query ? `?${query}` : ''}`);
  },

  /**
   * Get exchange details by ID
   */
  async get(id: string): Promise<ExchangeDetails> {
    return apiClient.request(`/exchanges/${id}`);
  },
};
